import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Observable } from "rxjs";
import { IFiatDepositInfoData } from "../entities/checkout.amount.model";

const initialState: IFiatDepositInfoData = undefined;

@Injectable({ providedIn: "root" })
export class FiatDepositInfosState extends StateService<IFiatDepositInfoData> {
	constructor() {
		super(initialState);
	}

	getFiatDepositInfos$(): Observable<IFiatDepositInfoData> {
		return this.select((state: IFiatDepositInfoData) => state);
	}

	setFiatDepositInfos(state: IFiatDepositInfoData): void {
		this.setState(state);
	}

	isFiatDepositInfosLoaded(): boolean {
		return this.isStateLoaded();
	}
}
